import React, { useState, useEffect, useCallback } from 'react';
import PanelLayout from '../Panel/PanelLayout';
import { bpAPI } from '../../services/api';
import { Search } from 'lucide-react';

const C = { surface: '#FFFFFF', border: '#e8e8f1', borderSoft: '#f0f0f6', ink: '#14142b', muted: '#6e6e86', primary: '#7c3aed', radius: 14, radiusSm: 8 };

const BPMerchants = () => {
  const [merchants, setMerchants] = useState([]);
  const [meta, setMeta]           = useState({});
  const [loading, setLoading]     = useState(true);
  const [search, setSearch]       = useState('');

  const load = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const res = await bpAPI.merchants({ search, page });
      setMerchants(res.data.data);
      setMeta(res.data.meta || {});
    } catch {}
    finally { setLoading(false); }
  }, [search]);

  useEffect(() => { load(); }, [load]);

  return (
    <PanelLayout role="business_partner" title="My Merchants" breadcrumb="Dashboard / Merchants">
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>

        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 14 }}>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: C.ink, letterSpacing: '-.02em' }}>My Merchants</h1>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: C.muted }}>Merchants you've referred to the platform.</p>
          </div>
          <div style={{ background: C.surface, border: `1.5px solid ${C.border}`, borderRadius: C.radius, display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
            <Search size={14} style={{ marginLeft: 14, color: C.muted, flexShrink: 0 }} />
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by username or email…"
              style={{ flex: 1, padding: '12px 14px', border: 'none', outline: 'none', fontSize: 13, background: 'transparent', color: C.ink, fontFamily: 'inherit' }} />
          </div>
        </div>

        <div style={{ border: '1px solid #e8e8f1', borderRadius: 14, overflow: 'hidden' }}>
          <div style={{
            display: 'grid', gridTemplateColumns: '1.5fr 1.5fr 100px 120px',
            background: '#f9f9fc', padding: '10px 16px',
            fontSize: 10, fontWeight: 700, color: '#4a4a6a', letterSpacing: 1, textTransform: 'uppercase',
          }}>
            <span>Merchant</span><span>Email</span><span>Status</span><span>Joined</span>
          </div>

          {loading && (
            <div style={{ textAlign: 'center', padding: 60, color: '#6e6e86' }}>Loading…</div>
          )}

          {!loading && merchants.length === 0 && (
            <div style={{ textAlign: 'center', padding: 60, color: '#6e6e86', fontSize: 13 }}>
              No merchants found. Share your referral link to get started.
            </div>
          )}

          {!loading && merchants.map((m, i) => (
            <div key={m.id} style={{
              display: 'grid', gridTemplateColumns: '1.5fr 1.5fr 100px 120px',
              padding: '14px 16px', alignItems: 'center',
              borderTop: '1px solid #f0f0f6',
              background: i % 2 === 0 ? '#fff' : '#FAFAFA',
            }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#14142b' }}>{m.username}</div>
                <div style={{ fontSize: 10, color: '#6e6e86', fontFamily: 'monospace' }}>{m.mid}</div>
              </div>
              <div style={{ fontSize: 12, color: '#4a4a6a' }}>{m.email}</div>
              <span style={{
                fontSize: 11, fontWeight: 700, padding: '2px 10px', borderRadius: 20,
                background: m.account_status === 'active' ? '#D1FAE5' : '#FEF3C7',
                color: m.account_status === 'active' ? '#059669' : '#D97706',
                display: 'inline-block',
              }}>{m.account_status}</span>
              <div style={{ fontSize: 12, color: '#6e6e86' }}>
                {m.created_at ? new Date(m.created_at).toLocaleDateString('en-IN') : '—'}
              </div>
            </div>
          ))}
        </div>

        {meta.last_page > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16 }}>
            {Array.from({ length: meta.last_page }, (_, i) => i + 1).map(page => (
              <button
                key={page}
                onClick={() => load(page)}
                style={{
                  width: 36, height: 36, borderRadius: 8, border: '1px solid #e8e8f1',
                  background: page === meta.current_page ? '#14142b' : '#fff',
                  color: page === meta.current_page ? '#fff' : '#14142b',
                  fontSize: 13, fontWeight: 600, cursor: 'pointer',
                }}
              >{page}</button>
            ))}
          </div>
        )}
      </div>
    </PanelLayout>
  );
};

export default BPMerchants;
